export default __webpack_public_path__ + "static/media/Docente.5fbb921d.png";